import { createFileRoute } from "@tanstack/react-router";

import { SalesforceFormPage } from "~/pages/connection-new/salesforce-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/salesforce",
)({
  component: SalesforceFormPage,
});
